<div
  [class]="
    labelRight
      ? 'flex flex-row items-center gap-2'
      : 'flex flex-col items-center gap-1.5'
  "
>
  <div class="relative flex items-center justify-center">
    <input
      type="checkbox"
      [checked]="checked"
      (change)="toggleCheck()"
      class="w-[18px] h-[18px] cursor-pointer appearance-none border border-slate-300 rounded transition-all duration-200 bg-white checked:bg-purple-600 checked:border-purple-600"
    />
    <!-- Checkmark SVG -->
    @if (checked) {
    <svg
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none"
      fill="none"
      stroke="white"
      viewBox="0 0 24 24"
      stroke-width="3"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M5 13l4 4L19 7"
      ></path>
    </svg>
    }
  </div>
  <span class="text-gray-700 text-[13px] font-normal">{{ label }}</span>
</div>
